import { render, staticRenderFns } from "./TuoleleIndex.vue?vue&type=template&id=ca330640&scoped=true&"
import script from "./TuoleleIndex.vue?vue&type=script&lang=js&"
export * from "./TuoleleIndex.vue?vue&type=script&lang=js&"
import style0 from "./TuoleleIndex.vue?vue&type=style&index=0&id=ca330640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca330640",
  null
  
)

export default component.exports